import _ from 'lodash';

// Import api
import { api } from 'store/api';

// Import types
import type { InvoiceInfoType } from 'types/api/invoice';

const enhancedApi = api.enhanceEndpoints({
	addTagTypes: ['invoice_info']
});

export const invoiceApi = enhancedApi.injectEndpoints({
	endpoints: (builder) => ({
		getInvoiceInfo: builder.query<InvoiceInfoType | null, void>({
			query: () => ({ url: '/invoice/info' }),
			keepUnusedDataFor: 0,
			providesTags: ['invoice_info'],
			transformResponse: (response: InvoiceInfoType) => (_.isEmpty(response) ? null : response)
		}),
		updateInvoiceInfo: builder.mutation<InvoiceInfoType, { need_invoice: boolean; client: InvoiceInfoType }>({
			query: (body) => ({ url: '/invoice/info', method: 'POST', body }),
			invalidatesTags: (result, error) => (error ? [] : ['invoice_info'])
		})
	})
});

export const { useGetInvoiceInfoQuery, useUpdateInvoiceInfoMutation } = invoiceApi;
